import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

// Create a new playlist
export const createPlaylist = async (playlistData) => {
  const response = await api.post('/playlists', playlistData);
  return response.data;
};

// Get all playlists with optional pagination
export const getAllPlaylists = async (page = 1, limit = 10) => {
  const response = await api.get(`/playlists?page=${page}&limit=${limit}`);
  return response.data;
};

// Get a playlist by ID
export const getPlaylistById = async (id) => {
  const response = await api.get(`/playlists/${id}`);
  return response.data;
};

// Update a playlist
export const updatePlaylist = async ({ id, ...updateData }) => {
  const response = await api.put(`/playlists/${id}`, updateData);
  return response.data;
};

// Delete a playlist
export const deletePlaylist = async (id) => {
  const response = await api.delete(`/playlists/${id}`);
  return response.data;
};

// Get playlists for the current authenticated user
export const getUserPlaylists = async (page = 1, limit = 10) => {
  const response = await api.get(`/user/playlists?page=${page}&limit=${limit}`);
  return response.data;
};

// Get playlists by content type
export const getPlaylistsByType = async (type, page = 1, limit = 10) => {
  const response = await api.get(`/playlists/type/${type}?page=${page}&limit=${limit}`);
  return response.data;
};

// Get playlist statistics
export const getPlaylistStats = async () => {
  const response = await api.get('/playlists/stats');
  return response.data;
};

// Check if content is in user's playlist
export const checkContentInPlaylist = async (item_type, content_id) => {
  const response = await api.get(`/playlists/check?item_type=${item_type}&content_id=${content_id}`);
  return response.data;
};